import axios from "axios";

// Global resilience: a request timeout so nothing spins forever, and automatic
// retries when the gateway answers 502/503/504 (backend restarting / brief outage).
const TRANSIENT = new Set([502, 503, 504]);
const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1500;

axios.defaults.timeout = 60000;

axios.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const status = error.response?.status;
  const isTimeout = error.code === "ECONNABORTED" || error.code === "ETIMEDOUT";
  const isNetwork = !error.response && !isTimeout && error.message === "Network Error";
  const method = (cfg?.method || "get").toLowerCase();
  const idempotent = method === "get" || method === "head" || cfg?.retryUnsafe;
  const transient = TRANSIENT.has(status) || (idempotent && (isNetwork || isTimeout));
  if (!cfg || !transient) {
    if (TRANSIENT.has(status) || isTimeout) {
      error.message = isTimeout
        ? "The server took too long to respond — please try again"
        : "The server is briefly unavailable — please try again in a moment";
    }
    return Promise.reject(error);
  }
  cfg.__retryCount = (cfg.__retryCount || 0) + 1;
  if (cfg.__retryCount > MAX_RETRIES) {
    error.message = "The server is briefly unavailable — please try again in a moment";
    return Promise.reject(error);
  }
  await new Promise((r) => setTimeout(r, RETRY_DELAY_MS * cfg.__retryCount));
  return axios(cfg);
});
